import { JSX as IonicJSX } from '@ionic/core';
import { IonInput } from '@ionic/react';
import { PropsWithChildren } from 'react';

import { Icon, IconName } from '@/components/Icon';
import { IconRotate, IconSize } from '@/components/Icon/types';
import styles from '@/components/Input/index.module.css';

import { mergeClassNames } from '@/utils/mergeClassNames';

type IonicInputProps = IonicJSX.IonInput;

interface InputProps extends IonicInputProps {
  leadingIcon?: IconName;
  leadingIconDirection?: IconRotate;
  trailingIcon?: IconName;
  trailingIconDirection?: IconRotate;
  /** Should the input be shown in an error state */
  hasError?: boolean;
  className?: string;
  variant?: 'primary' | 'secondary' | 'light';
}

export const Input = ({
  leadingIcon,
  leadingIconDirection,
  trailingIcon,
  trailingIconDirection,
  hasError,
  className,
  children,
  variant = 'primary',
  ...props
}: PropsWithChildren<InputProps>) => {
  return (
    <IonInput
      className={mergeClassNames(
        styles.input,
        hasError && styles.error,
        className,
        leadingIcon && styles['has-leading-icon'],
        trailingIcon && styles['has-trailing-icon'],
        styles[variant],
      )}
      {...props}>
      {leadingIcon && (
        <Icon
          className={mergeClassNames(styles.icon, styles['icon-left'], styles[variant])}
          direction={leadingIconDirection}
          name={leadingIcon}
          size={IconSize.small}
        />
      )}

      {children}

      {trailingIcon && (
        <Icon
          className={mergeClassNames(styles.icon, styles['icon-right'])}
          direction={trailingIconDirection}
          name={trailingIcon}
          size={IconSize.small}
        />
      )}
    </IonInput>
  );
};
